import './tabs.scss';

(($) => {
    function initTabs() {

        const tabsLabel = document.querySelectorAll('.tab-label')
        const tabsContent = document.querySelectorAll('.tab-content')

        const tabSwitch = (elmnt) => {

            tabsContent.forEach(e => { 
                if (elmnt.id+'-content' == e.id) {
                    e.classList.add('active')
                } else {
                    e.classList.remove('active')
                } 
            })

            tabsLabel.forEach(tab => tab.classList.remove('active'))
            elmnt.classList.add('active');
        }

        tabsLabel.forEach(tab => {
            tab.addEventListener("click", () => {
                tabSwitch(tab)
            })
        })

        const curveHeight = () => {
            let tabsHeight = []

            tabsContent.forEach(tab => {
                tabsHeight.push(tab.clientHeight)
            })

            console.log(tabsHeight.sort((a,b)=>b-a))

            tabsContent.forEach(tab => {
                if(tab.clientHeight !== tabsHeight[0]) {
                    tab.style.position = 'absolute'
                }
            })
        }

        curveHeight()
    }
    if ($("body").hasClass("wp-admin")) {
        $(document).on("initTabs", initTabs);
    } else {
        $(document).ready(initTabs);
    }
})(jQuery);